import { render, staticRenderFns } from "./ChooseApprover.vue?vue&type=template&id=a38bcef2&scoped=true"
import script from "./ChooseApprover.vue?vue&type=script&lang=js"
export * from "./ChooseApprover.vue?vue&type=script&lang=js"
import style0 from "./ChooseApprover.vue?vue&type=style&index=0&id=a38bcef2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38bcef2",
  null
  
)

export default component.exports